import angular from 'angular';
import moment from 'moment';
import URLS from 'Helpers/urls';

(function() {
    'use strict';

    angular.module('app').component('hourPickerModal', {
        template: require('./hour-picker-modal.html'),
        controller: HourPickerModalCtrl,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    HourPickerModalCtrl.$inject = [
        '$scope',
        '$cookies',
        '$timeout',
        'QueryService'
    ];

    function HourPickerModalCtrl($scope, $cookies, $timeout, QueryService) {
        var vm = this;
        vm.content = null;

        vm.scheduled_date = moment().utcOffset('+9:00');


        vm.approve = approve;
        vm.cancel = cancel;
        vm.getClass = getClass;
        vm.confirm = confirm;

        vm.$onInit = function() {
            vm.content = angular.copy(vm.resolve.content);
            getSchedule();
        };

        vm.tomorrow = false;
        vm.start_hour = 6;
        vm.end_hour = 25;
        vm.hour_divisions = 4;

        vm.minutes_increment = 60 / vm.hour_divisions;
        
        //set to next monday if weekend
        function move_scheduled_date(){
            vm.scheduled_date = new Date();

            if(vm.scheduled_date.getDay() === 6){
                vm.scheduled_date.setHours(vm.scheduled_date.getHours()+48);
            } else
            if(vm.scheduled_date.getDay() === 5){
                vm.scheduled_date.setHours(vm.scheduled_date.getHours()+72);
            }else{
                vm.scheduled_date.setHours(vm.scheduled_date.getHours() + 24);
            }
            while(vm.scheduled_date.getDay() === 0 || vm.scheduled_date.getDay() === 6 || vm.disabled_dates.includes(vm.scheduled_date.format('mm-dd'))){
                vm.scheduled_date.setHours(vm.scheduled_date.getHours()+24);
            }
        }
        

        
        //get limits
        console.log('Getting Limits');
        vm.loading = true;
        var request = {
            method: 'GET',
            body: false,
            params: { date: new Date().format('yyyy-mm-dd')},
            hasFile: false,
            route: URLS.base + `/demo_class_limit`,
            cache: false
        };

        QueryService.query(request)
            .then(
                function(response) {
                    const data = response.data.data.disabled_dates.map(s => s.date);
                    vm.disabled_dates = data;
                    move_scheduled_date();
                    getSchedule();

                    console.log(data);
                },
                function(error) {
                    // logger.errorFormatResponse(error);
                }
            )
            .finally(function() {
                vm.loading = false;
            });
        //end get limits

        vm.clicked_dates = [];

        vm.hours = [];
        for (let i = vm.start_hour; i < vm.end_hour; i++) {
            vm.hours.push(i);
        }

        vm.minutes = [];
        for (let i = 0; i < vm.hour_divisions; i++) {
            vm.minutes.push(vm.minutes_increment * i);
        }

        vm.set_tomorrow = function(val) {
            vm.tomorrow = val;
        };

        vm.getSchedule = getSchedule;
        function getSchedule() {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: false,
                hasFile: false,
                route:
                    URLS.base +
                    `/schedule/${(new Date(vm.scheduled_date)).getDay()}/1/available/`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.available_schedule = response.data.data.items;
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
            }

        getLimit();
        function getLimit() {
            
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: { date: new Date().format('yyyy-mm-dd')},
                hasFile: false,
                route: URLS.base + `/demo_class_limit`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        vm.demo_count = data.count;
                        vm.demo_limit = data.limit;
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }


        // hour: 0 - 24
        function approve(hour, minute) {
            let tomorrow = new Date();
            let this_date = new Date(vm.scheduled_date);

            tomorrow.setHours(tomorrow.getHours() + 24);
            this_date.setHours(hour);
            this_date.setMinutes(minute);

            const available = vm.available_schedule
                .map(h => {
                    return h.hours;
                })
                .indexOf(hour * 4 + minute / 15)
                ;

            if (available < 0 || tomorrow - this_date > 0) {
            } else {
                const c = vm.clicked_dates.filter(x => {
                    return x.hour == hour && x.minute == minute;
                })[0];

                if (c) {
                    const index = vm.clicked_dates.indexOf(c);
                    vm.clicked_dates.splice(index, 1);
                } else {
                    vm.clicked_dates.push({
                        hour: hour,
                        minute: minute
                    });
                }
            }
        }

        // hour: 0 - 24
        function getClass(hour, minute) {

            let tomorrow = new Date();
            let this_date = new Date(vm.scheduled_date);

            tomorrow.setHours(tomorrow.getHours() + 24);
            this_date.setHours(hour);
            this_date.setMinutes(minute);

            if(tomorrow - this_date > 0){
                return 'schedule-unavailable';
            }
            
            const c = vm.clicked_dates.filter(x => {
                return x.hour == hour && x.minute == minute;
            })[0];

            const available = vm.available_schedule
                ? vm.available_schedule
                      .map(h => {
                          return h.hours;
                      })
                      .indexOf(hour * 4 + minute / 15)
                : null
            ;

            return c ? 'clicked_hour' : available >= 0 && vm.demo_count < vm.demo_limit? 'available' : 'schedule-unavailable';
        }

        function confirm() {
            const dates = [];

            vm.clicked_dates.forEach(date => {
                var s = new Date(vm.scheduled_date.getTime());

                s = moment(s).utcOffset(9).hour(date.hour);
                s = moment(s).utcOffset(9).minute(date.minute);

                dates.push({
                    date: s,
                    day: s.day(),
                    hour: date.hour * 4 + date.minute / 15
                });
            });

            vm.modalInstance.close(dates);
        }

        function cancel() {
            vm.modalInstance.close();
        }

        vm.disabled = function(date) {
            return date.date.getDay() === 0 || date.date.getDay() === 6 || (vm.disabled_dates||[]).includes(date.date.format('mm-dd'));
        };
        vm.date_options = {
            startingDay: 0,
            dateDisabled: vm.disabled
        };

        vm.date_opened = false;
        vm.open = function($event) {
            vm.date_opened = true;
        };
    }
})();



// WEBPACK FOOTER //
// ./src/app/shared/modals/hour-picker-modal/hour-picker-modal.component.js